import { useState } from "react";
import { Bell, BellOff, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const PushPrompt = ({ onSubscribe, isSubscribed, supported, permission }) => {
  const [dismissed, setDismissed] = useState(false);

  if (!supported || isSubscribed || dismissed || permission === "denied") return null;

  const handleEnable = async () => {
    const success = await onSubscribe();
    if (success) {
      toast.success("Notifications enabled! You'll be alerted for car updates.");
    } else {
      toast.error("Could not enable notifications. Check browser settings.");
    }
  };

  return (
    <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/20 rounded-xl p-3 flex items-center gap-3" data-testid="push-prompt">
      <Bell className="w-5 h-5 text-[#D4AF37] shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-medium">Enable notifications?</p>
        <p className="text-gray-400 text-xs">Get alerts when your car status changes</p>
      </div>
      <div className="flex items-center gap-1.5 shrink-0">
        <Button
          size="sm"
          onClick={handleEnable}
          className="h-7 px-3 bg-[#D4AF37] hover:bg-[#C4A030] text-black text-xs font-semibold rounded-lg"
          data-testid="push-enable-btn"
        >
          Enable
        </Button>
        <button
          onClick={() => setDismissed(true)}
          className="h-7 w-7 flex items-center justify-center text-gray-500 hover:text-white transition-colors"
          data-testid="push-dismiss-btn"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default PushPrompt;
